function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import { useUniquePrefix } from "../../../hooks/useUniquePrefix";
var PageNotFound = function(_param) {
    var width = _param.width, height = _param.height, title = _param.title, rest = _objectWithoutProperties(_param, [
        "width",
        "height",
        "title"
    ]);
    var uniqueID = useUniquePrefix();
    return _jsxs("svg", _objectSpread({}, rest, {
        width: width,
        height: height,
        viewBox: "0 0 255 315",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        role: "img",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: [
            _jsx("title", {
                children: title
            }),
            _jsxs("defs", {
                children: [
                    _jsxs("linearGradient", {
                        x1: "50%",
                        y1: "0%",
                        x2: "50%",
                        y2: "100%",
                        id: "".concat(uniqueID, "PageNotFound-linearGradient-1"),
                        children: [
                            _jsx("stop", {
                                offset: "0%",
                                stopColor: "#00A7FA"
                            }),
                            _jsx("stop", {
                                offset: "100%",
                                stopColor: "#0076F3"
                            })
                        ]
                    }),
                    _jsxs("linearGradient", {
                        x1: "36.7798241%",
                        y1: "50%",
                        x2: "57.9291195%",
                        y2: "63.5717493%",
                        id: "".concat(uniqueID, "PageNotFound-linearGradient-4"),
                        children: [
                            _jsx("stop", {
                                offset: "0%",
                                stopColor: "#FFFFFF",
                                stopOpacity: "0"
                            }),
                            _jsx("stop", {
                                offset: "100%",
                                stopColor: "#FFFFFF",
                                stopOpacity: "0.3"
                            })
                        ]
                    }),
                    _jsxs("linearGradient", {
                        x1: "3.0565022%",
                        y1: "3.81578571%",
                        x2: "3.0565022%",
                        y2: "100%",
                        id: "".concat(uniqueID, "PageNotFound-linearGradient-5"),
                        children: [
                            _jsx("stop", {
                                offset: "0%",
                                stopColor: "#0071F2"
                            }),
                            _jsx("stop", {
                                offset: "100%",
                                stopColor: "#00EEFF"
                            })
                        ]
                    }),
                    _jsxs("linearGradient", {
                        x1: "35.81876%",
                        y1: "0%",
                        x2: "50%",
                        y2: "74.4382679%",
                        id: "".concat(uniqueID, "PageNotFound-linearGradient-12"),
                        children: [
                            _jsx("stop", {
                                offset: "0%",
                                stopColor: "#FFFFFF",
                                stopOpacity: "0"
                            }),
                            _jsx("stop", {
                                offset: "100%",
                                stopColor: "#FFFFFF"
                            })
                        ]
                    }),
                    _jsxs("linearGradient", {
                        x1: "35.81876%",
                        y1: "26.2596298%",
                        x2: "56.6275927%",
                        y2: "60.1403897%",
                        id: "".concat(uniqueID, "PageNotFound-linearGradient-21"),
                        children: [
                            _jsx("stop", {
                                offset: "0%",
                                stopColor: "#FFFFFF",
                                stopOpacity: "0"
                            }),
                            _jsx("stop", {
                                offset: "97.6810874%",
                                stopColor: "#FFFFFF",
                                stopOpacity: "0.4"
                            })
                        ]
                    }),
                    _jsxs("linearGradient", {
                        x1: "3.0565022%",
                        y1: "3.81578571%",
                        x2: "3.0565022%",
                        y2: "100%",
                        id: "".concat(uniqueID, "PageNotFound-linearGradient-22"),
                        children: [
                            _jsx("stop", {
                                offset: "0%",
                                stopColor: "#E1E1E1"
                            }),
                            _jsx("stop", {
                                offset: "100%",
                                stopColor: "#FFFFFF"
                            })
                        ]
                    }),
                    _jsx("rect", {
                        id: "".concat(uniqueID, "PageNotFound-path-2"),
                        x: "33.3046159",
                        y: "91.4760014",
                        width: "75.6923089",
                        height: "142.128002",
                        rx: "4.73324424"
                    }),
                    _jsx("rect", {
                        id: "".concat(uniqueID, "PageNotFound-path-6"),
                        x: "33.3046159",
                        y: "91.4760014",
                        width: "75.6923089",
                        height: "142.128002",
                        rx: "4.73324424"
                    }),
                    _jsx("rect", {
                        id: "".concat(uniqueID, "PageNotFound-path-10"),
                        x: "0",
                        y: "0",
                        width: "22.8893542",
                        height: "22.1356803"
                    }),
                    _jsx("rect", {
                        id: "".concat(uniqueID, "PageNotFound-path-13"),
                        x: "0",
                        y: "0",
                        width: "75.6923089",
                        height: "142.128002",
                        rx: "4.73324424"
                    }),
                    _jsx("rect", {
                        id: "".concat(uniqueID, "PageNotFound-path-15"),
                        x: "43.9015391",
                        y: "89.9640014",
                        width: "75.6923089",
                        height: "142.128002",
                        rx: "4.73324424"
                    }),
                    _jsx("rect", {
                        id: "".concat(uniqueID, "PageNotFound-path-18"),
                        x: "-37.8461544",
                        y: "80.1360012",
                        width: "75.6923089",
                        height: "142.128002",
                        rx: "4.73324424"
                    }),
                    _jsx("rect", {
                        id: "".concat(uniqueID, "PageNotFound-path-23"),
                        x: "77.206155",
                        y: "-7.10542736e-15",
                        width: "75.6923089",
                        height: "142.128002",
                        rx: "4.73324424"
                    }),
                    _jsxs("filter", {
                        x: "-51.5%",
                        y: "-19.7%",
                        width: "203.0%",
                        height: "157.7%",
                        filterUnits: "objectBoundingBox",
                        id: "".concat(uniqueID, "PageNotFound-filter-3"),
                        children: [
                            _jsx("feOffset", {
                                dx: "0",
                                dy: "15",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter1"
                            }),
                            _jsx("feOffset", {
                                dx: "0",
                                dy: "2",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter2"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "10.5",
                                in: "shadowOffsetOuter1",
                                result: "shadowBlurOuter1"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "6",
                                in: "shadowOffsetOuter2",
                                result: "shadowBlurOuter2"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0.560784314 0 0 0 0 0.964705882 0 0 0 0.324501812 0",
                                type: "matrix",
                                in: "shadowBlurOuter1",
                                result: "shadowMatrixOuter1"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0.560784314 0 0 0 0 0.964705882 0 0 0 0.402032382 0",
                                type: "matrix",
                                in: "shadowBlurOuter2",
                                result: "shadowMatrixOuter2"
                            }),
                            _jsxs("feMerge", {
                                children: [
                                    _jsx("feMergeNode", {
                                        in: "shadowMatrixOuter1"
                                    }),
                                    _jsx("feMergeNode", {
                                        in: "shadowMatrixOuter2"
                                    })
                                ]
                            })
                        ]
                    }),
                    _jsxs("filter", {
                        x: "-61.7%",
                        y: "-28.7%",
                        width: "289.5%",
                        height: "212.9%",
                        filterUnits: "objectBoundingBox",
                        id: "".concat(uniqueID, "PageNotFound-filter-7"),
                        children: [
                            _jsx("feMorphology", {
                                radius: "1.22016002",
                                operator: "dilate",
                                in: "SourceAlpha",
                                result: "shadowSpreadOuter1"
                            }),
                            _jsx("feOffset", {
                                dx: "25",
                                dy: "48",
                                in: "shadowSpreadOuter1",
                                result: "shadowOffsetOuter1"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "15.5",
                                in: "shadowOffsetOuter1",
                                result: "shadowBlurOuter1"
                            }),
                            _jsx("feComposite", {
                                in: "shadowBlurOuter1",
                                in2: "SourceAlpha",
                                operator: "out",
                                result: "shadowBlurOuter1"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.133406929 0",
                                type: "matrix",
                                in: "shadowBlurOuter1"
                            })
                        ]
                    }),
                    _jsxs("filter", {
                        x: "-60.9%",
                        y: "-28.2%",
                        width: "287.9%",
                        height: "212.0%",
                        filterUnits: "objectBoundingBox",
                        id: "".concat(uniqueID, "PageNotFound-filter-9"),
                        children: [
                            _jsx("feMorphology", {
                                radius: "0.605160009",
                                operator: "dilate",
                                in: "SourceAlpha",
                                result: "shadowSpreadOuter1"
                            }),
                            _jsx("feMorphology", {
                                radius: "1",
                                operator: "erode",
                                in: "SourceAlpha",
                                result: "shadowInner"
                            }),
                            _jsx("feOffset", {
                                dx: "25",
                                dy: "48",
                                in: "shadowSpreadOuter1",
                                result: "shadowOffsetOuter1"
                            }),
                            _jsx("feOffset", {
                                dx: "25",
                                dy: "48",
                                in: "shadowInner",
                                result: "shadowInner"
                            }),
                            _jsx("feComposite", {
                                in: "shadowOffsetOuter1",
                                in2: "shadowInner",
                                operator: "out",
                                result: "shadowOffsetOuter1"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "15.5",
                                in: "shadowOffsetOuter1",
                                result: "shadowBlurOuter1"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.133406929 0",
                                type: "matrix",
                                in: "shadowBlurOuter1"
                            })
                        ]
                    }),
                    _jsx("filter", {
                        x: "-20.7%",
                        y: "-6.8%",
                        width: "207.5%",
                        height: "169.2%",
                        filterUnits: "objectBoundingBox",
                        id: "".concat(uniqueID, "PageNotFound-filter-16"),
                        children: _jsx("feGaussianBlur", {
                            stdDeviation: "3.02580005",
                            in: "SourceGraphic"
                        })
                    }),
                    _jsxs("filter", {
                        x: "-72.9%",
                        y: "-34.6%",
                        width: "311.9%",
                        height: "224.8%",
                        filterUnits: "objectBoundingBox",
                        id: "".concat(uniqueID, "PageNotFound-filter-17"),
                        children: [
                            _jsx("feMorphology", {
                                radius: "0.605160009",
                                operator: "dilate",
                                in: "SourceAlpha",
                                result: "shadowSpreadOuter1"
                            }),
                            _jsx("feMorphology", {
                                radius: "1",
                                operator: "erode",
                                in: "SourceAlpha",
                                result: "shadowInner"
                            }),
                            _jsx("feOffset", {
                                dx: "25",
                                dy: "48",
                                in: "shadowSpreadOuter1",
                                result: "shadowOffsetOuter1"
                            }),
                            _jsx("feOffset", {
                                dx: "25",
                                dy: "48",
                                in: "shadowInner",
                                result: "shadowInner"
                            }),
                            _jsx("feComposite", {
                                in: "shadowOffsetOuter1",
                                in2: "shadowInner",
                                operator: "out",
                                result: "shadowOffsetOuter1"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "15.5",
                                in: "shadowOffsetOuter1",
                                result: "shadowBlurOuter1"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.133406929 0",
                                type: "matrix",
                                in: "shadowBlurOuter1"
                            })
                        ]
                    }),
                    _jsx("filter", {
                        x: "-42.7%",
                        y: "-15.0%",
                        width: "185.5%",
                        height: "148.3%",
                        filterUnits: "objectBoundingBox",
                        id: "".concat(uniqueID, "PageNotFound-filter-19"),
                        children: _jsx("feGaussianBlur", {
                            stdDeviation: "3.78225006",
                            in: "SourceGraphic"
                        })
                    }),
                    _jsxs("filter", {
                        x: "-66.5%",
                        y: "-27.7%",
                        width: "233.0%",
                        height: "173.7%",
                        filterUnits: "objectBoundingBox",
                        id: "".concat(uniqueID, "PageNotFound-filter-20"),
                        children: [
                            _jsx("feOffset", {
                                dx: "0",
                                dy: "15",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter1"
                            }),
                            _jsx("feOffset", {
                                dx: "0",
                                dy: "2",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter2"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "10.5",
                                in: "shadowOffsetOuter1",
                                result: "shadowBlurOuter1"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "6",
                                in: "shadowOffsetOuter2",
                                result: "shadowBlurOuter2"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0.560784314 0 0 0 0 0.964705882 0 0 0 0.324501812 0",
                                type: "matrix",
                                in: "shadowBlurOuter1",
                                result: "shadowMatrixOuter1"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0.560784314 0 0 0 0 0.964705882 0 0 0 0.402032382 0",
                                type: "matrix",
                                in: "shadowBlurOuter2",
                                result: "shadowMatrixOuter2"
                            }),
                            _jsxs("feMerge", {
                                children: [
                                    _jsx("feMergeNode", {
                                        in: "shadowMatrixOuter1"
                                    }),
                                    _jsx("feMergeNode", {
                                        in: "shadowMatrixOuter2"
                                    })
                                ]
                            })
                        ]
                    }),
                    _jsxs("filter", {
                        x: "-75.0%",
                        y: "-35.0%",
                        width: "331.9%",
                        height: "239.0%",
                        filterUnits: "objectBoundingBox",
                        id: "".concat(uniqueID, "PageNotFound-filter-24"),
                        children: [
                            _jsx("feMorphology", {
                                radius: "0.756450012",
                                operator: "dilate",
                                in: "SourceAlpha",
                                result: "shadowSpreadOuter1"
                            }),
                            _jsx("feOffset", {
                                dx: "31",
                                dy: "60",
                                in: "shadowSpreadOuter1",
                                result: "shadowOffsetOuter1"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "19",
                                in: "shadowOffsetOuter1",
                                result: "shadowBlurOuter1"
                            }),
                            _jsx("feComposite", {
                                in: "shadowBlurOuter1",
                                in2: "SourceAlpha",
                                operator: "out",
                                result: "shadowBlurOuter1"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0",
                                type: "matrix",
                                in: "shadowBlurOuter1"
                            })
                        ]
                    }),
                    _jsx("path", {
                        d: "M152.898464,90.7200014 L192.063799,90.7200014 C194.679532,90.7200014 196.800003,92.8378864 196.800003,95.4504299 L196.800003,228.117575 C196.800003,230.730119 194.679532,232.848004 192.063799,232.848004 L125.843899,232.848004 C123.228165,232.848004 121.107694,230.730119 121.107694,228.117575 L121.107694,138.922769",
                        id: "".concat(uniqueID, "PageNotFound-path-8")
                    })
                ]
            }),
            _jsx("g", {
                stroke: "none",
                fill: "none",
                strokeWidth: "1",
                fillRule: "evenodd",
                children: _jsx("g", {
                    id: "".concat(uniqueID, "PageNotFound-Hero/Error/Page-Not-Found"),
                    transform: "translate(-87.000000, -32.000000)",
                    children: _jsxs("g", {
                        transform: "translate(88.000000, 33.000000)",
                        children: [
                            _jsxs("g", {
                                transform: "translate(0.000000, 70.308001)",
                                stroke: "#E1E1E1",
                                strokeWidth: "0.756450012",
                                children: [
                                    _jsx("rect", {
                                        id: "".concat(uniqueID, "PageNotFound-Rectangle-Copy-10"),
                                        x: "0",
                                        y: "29.0818728",
                                        width: "76.2978473",
                                        height: "141.77413",
                                        rx: "4.73324424"
                                    }),
                                    _jsx("rect", {
                                        id: "".concat(uniqueID, "PageNotFound-Rectangle-Copy-11"),
                                        x: "18.1661541",
                                        y: "10.9057023",
                                        width: "76.2978473",
                                        height: "141.77413",
                                        rx: "4.73324424"
                                    }),
                                    _jsx("rect", {
                                        id: "".concat(uniqueID, "PageNotFound-Rectangle-Copy-12"),
                                        x: "32.6990774",
                                        y: "0",
                                        width: "76.2978473",
                                        height: "141.77413",
                                        rx: "4.73324424"
                                    })
                                ]
                            }),
                            _jsxs("g", {
                                children: [
                                    _jsx("use", {
                                        fill: "black",
                                        filter: "url(#".concat(uniqueID, "PageNotFound-filter-3)"),
                                        fillOpacity: "1",
                                        xlinkHref: "#".concat(uniqueID, "PageNotFound-path-2")
                                    }),
                                    _jsx("use", {
                                        fill: "url(#".concat(uniqueID, "PageNotFound-linearGradient-1)"),
                                        fillRule: "evenodd",
                                        xlinkHref: "#".concat(uniqueID, "PageNotFound-path-2")
                                    })
                                ]
                            }),
                            _jsxs("g", {
                                children: [
                                    _jsx("use", {
                                        fill: "black",
                                        filter: "url(#".concat(uniqueID, "PageNotFound-filter-7)"),
                                        fillOpacity: "1",
                                        xlinkHref: "#".concat(uniqueID, "PageNotFound-path-6")
                                    }),
                                    _jsx("use", {
                                        stroke: "url(#".concat(uniqueID, "PageNotFound-linearGradient-5)"),
                                        fill: "url(#".concat(uniqueID, "PageNotFound-linearGradient-4)"),
                                        strokeWidth: "2.44032004",
                                        fillRule: "evenodd",
                                        xlinkHref: "#".concat(uniqueID, "PageNotFound-path-6")
                                    })
                                ]
                            }),
                            _jsxs("g", {
                                strokeDasharray: "6.051600187683107",
                                children: [
                                    _jsx("use", {
                                        fill: "black",
                                        filter: "url(#".concat(uniqueID, "PageNotFound-filter-9)"),
                                        fillOpacity: "1",
                                        xlinkHref: "#".concat(uniqueID, "PageNotFound-path-8")
                                    }),
                                    _jsx("use", {
                                        stroke: "url(#".concat(uniqueID, "PageNotFound-linearGradient-5)"),
                                        strokeWidth: "1.21032002",
                                        xlinkHref: "#".concat(uniqueID, "PageNotFound-path-8")
                                    })
                                ]
                            }),
                            _jsxs("g", {
                                id: "".concat(uniqueID, "PageNotFound-People/Person-Copy-7"),
                                transform: "translate(67.956924, 154.980002)",
                                children: [
                                    _jsxs("g", {
                                        id: "".concat(uniqueID, "PageNotFound-Bottom/Standing/2"),
                                        transform: "translate(10.249231, 68.040001)",
                                        children: [
                                            _jsx("path", {
                                                d: "M7.96623643,77.1868225 C13.9961052,76.2462702 16.802831,73.845018 18.8465234,76.3965181 C19.7755772,77.5564191 18.972165,78.2641122 17.649757,79.2541981 C16.3491032,80.2279967 13.7834909,81.8289186 9.95292018,84.0569637 C6.97784679,85.2542214 4.95238602,85.5701573 3.87653789,85.0047713 C3.06409704,83.9942708 2.81421768,82.4405233 3.12689981,80.3435289 C4.87893833,78.4690047 6.49205053,77.4167693 7.96623643,77.1868225 Z M30.4456341,77.8773729 C36.3470583,76.8882134 42.088379,75.5405252 42.666006,77.8773729 C43.1756768,79.9392973 41.5482604,80.6846838 39.8563677,81.5185149 L39.5177436,81.6868767 C39.4049917,81.7436679 39.2925674,81.8012685 39.1810848,81.8600947 C37.9176145,82.5267922 35.3034731,83.4792075 31.3386603,84.7173407 C28.1307215,85.415814 26.0280236,85.415814 25.0305667,84.7173407 C24.3723658,83.6339753 24.3723658,82.1166857 25.0305667,80.165472 C27.1995137,78.8816204 29.0045362,78.1189207 30.4456341,77.8773729 Z",
                                                fill: "#0071F2"
                                            }),
                                            _jsx("path", {
                                                d: "M25.9141432,0 C28.1100509,15.1840886 29.1129751,27.834422 30.6910344,40.1315051 C32.2690936,52.4285882 32.4257236,61.308081 32.4257236,78.839369 C32.4257236,79.7884632 31.8474939,80.3621402 30.6910344,80.5604002 C28.542492,80.9287399 26.797767,80.8296099 25.4568595,80.2630103 C22.8595229,62.0705517 19.2045945,51.8706452 16.7192811,43.54054 C16.5255122,44.7569282 16.3384556,45.9582133 16.1540807,47.1545182 L15.8659324,49.0324498 C15.8340449,49.2409797 15.8021809,49.4495211 15.7703211,49.6581282 L15.5790566,50.9109967 C15.5471357,51.120085 15.5151802,51.329348 15.4831705,51.5388401 L15.2903079,52.7989785 C14.1273736,60.3815345 12.8439996,68.4021954 10.5343026,79.4009873 C10.0827605,80.1699793 9.06927039,80.6467135 7.49383236,80.83119 C5.58058345,81.0552226 4.1315246,80.8658293 3.14665579,80.2630103 C3.14665579,69.7885071 2.98311695,62.6680269 2.83834486,55.8948417 L2.81302877,54.7025669 C2.70866596,49.7446766 2.62024747,44.8789298 2.62024747,38.9100251 C2.62024747,34.540787 2.52491981,31.369195 2.36155159,28.4464913 L2.32797882,27.864988 C2.31074692,27.5756145 2.29285281,27.2880973 2.27432376,27.0014878 L2.23642719,26.4291978 L2.23642719,26.4291978 L2.17651382,25.5716112 C1.76512045,19.8472197 1.11794766,13.8533706 0.45329233,0 L0.45329233,0 Z",
                                                fill: "#B2B3B7"
                                            }),
                                            _jsx("path", {
                                                d: "M3.57578331,1.42108547e-14 C9.1345282,21.3176907 13.0104314,31.1277635 15.5346276,39.2604484 L15.7027541,39.8062897 C15.8965214,40.4404001 16.0819729,41.0655006 16.2592698,41.686374 C16.4330438,42.2949106 16.6144376,42.9114297 16.8024958,43.5385439 C16.5745811,44.9680893 16.3549209,46.3767371 16.1381,47.7809714 L15.9453486,49.0324498 C15.9132968,49.2409797 15.8812686,49.4495211 15.8492446,49.6581282 L15.6569947,50.9109967 C15.6249093,51.120085 15.5927891,51.329348 15.5606145,51.5388401 L15.3667582,52.7989785 C14.1978316,60.3815345 12.9078448,68.4021954 10.5862467,79.4009873 C10.1323779,80.1699793 9.11366567,80.6467135 7.53010993,80.83119 C5.60700269,81.0552226 4.15047731,80.8658293 3.1605338,80.2630103 C3.1605338,69.7885071 2.9961523,62.6680269 2.85063425,55.8948417 L2.82518771,54.7025669 C2.72028715,49.7446766 2.63141307,44.8789298 2.63141307,38.9100251 C2.63141307,34.540787 2.53559422,31.369195 2.37138422,28.4464913 L2.33763846,27.864988 L2.33763846,27.864988 L2.3021177,27.288435 C2.29605237,27.1926616 2.28991511,27.0970243 2.28370694,27.0014878 L2.2456151,26.4291978 L2.2456151,26.4291978 L2.18539301,25.5716112 C1.77187986,19.8472197 1.12137241,13.8533706 0.45329233,0 L0.45329233,0 L3.57578331,1.42108547e-14 Z",
                                                fill: "#000000",
                                                fillOpacity: "0.15"
                                            })
                                        ]
                                    }),
                                    _jsxs("g", {
                                        id: "".concat(uniqueID, "PageNotFound-Body/4"),
                                        transform: "translate(0.000000, 7.560000)",
                                        children: [
                                            _jsx("path", {
                                                d: "M43.3491541,1.3692643 C69.8333093,8.2721079 67.4081789,22.7308516 41.4930246,30.6435925 C41.1392897,30.7515993 40.7918029,30.8547807 40.4504988,30.9532437 C40.5389561,32.3698035 40.5794605,33.9380989 40.5794605,35.6640195 L40.5794605,35.6640195 L40.5794605,52.727831 C40.5794605,64.9914838 44.4511221,66.1032738 35.521322,68.9731289 C26.5915218,71.842984 9.73744658,70.7694785 8.88590811,65.3262784 C9.82842799,63.5442413 10.3404471,61.2944082 10.5929825,58.783007 C5.55931324,54.5901412 0.166154128,48.1947365 0.166154128,44.1688391 C0.166154128,37.8603989 8.69342604,22.9592344 19.4873583,20.1297629 C21.0851797,19.3552254 22.8545826,18.9235181 24.7656814,18.9235181 C32.9688354,18.9235181 29.0815623,19.2917531 33.9520075,19.5293615 C34.2004272,19.5414809 34.4407471,19.5647666 34.6731471,19.5995564 C35.924919,19.2003238 37.2609493,18.9017464 38.6613044,18.7356278 C54.1248883,16.9012435 55.5792649,11.5082604 42.374836,6.13664412 C42.6171185,5.8010763 42.8278669,4.92487407 42.9945223,3.97499358 L43.0484238,3.65627847 C43.1877144,2.80251087 43.2910634,1.93152313 43.3496505,1.37127345 L43.3491541,1.3692643 Z M10.3223515,40.979764 L10.1893239,41.2091277 C9.60057299,42.2531131 9.24948087,43.2396836 9.13604754,44.1688391 C8.96762162,45.54845 9.48328217,47.2011982 10.6830292,49.1270836 C10.565098,46.3657407 10.3923314,43.5865211 10.3223515,40.979764 Z",
                                                fill: "#FDF9E7"
                                            }),
                                            _jsx("path", {
                                                d: "M10.3792937,35.8403571 C10.2747363,37.4266873 10.2735328,39.1612602 10.3223515,40.979764 C9.65294481,42.1091823 9.25773778,43.1720496 9.13604754,44.1688391 C8.96763356,45.5483522 9.48320905,47.2009638 10.682774,49.1266739 C10.8275112,52.4840385 10.8913259,55.8160566 10.5929825,58.783007 C5.55931324,54.5901412 0.166154128,48.1947365 0.166154128,44.1688391 C0.166154128,37.8598143 8.69500661,22.9564724 19.4903592,20.1289766 C14.2295256,22.6819705 10.8325064,28.9642755 10.3792937,35.8403571 Z",
                                                fill: "#000000",
                                                fillOpacity: "0.15"
                                            }),
                                            _jsx("path", {
                                                d: "M35.9217225,1.77506141 C37.6634735,0.0975698366 41.8843588,-0.147812745 44.3756382,1.77506141 C46.0364911,3.05697751 46.0364911,4.22093653 44.3756382,5.26693847 C41.8728664,6.548451 40.2323574,6.548451 39.4541112,5.26693847 C38.286742,3.34466968 38.286742,2.37495343 36.4984245,3.32503282 C34.7101069,4.27511221 34.1799715,3.45255298 35.9217225,1.77506141 Z",
                                                fill: "#DBB59D"
                                            })
                                        ]
                                    }),
                                    _jsxs("g", {
                                        id: "".concat(uniqueID, "PageNotFound-Head/Back/1"),
                                        transform: "translate(17.818462, 0.000000)",
                                        children: [
                                            _jsxs("g", {
                                                transform: "translate(0.513846, 4.536000)",
                                                children: [
                                                    _jsx("mask", {
                                                        id: "".concat(uniqueID, "PageNotFound-mask-11"),
                                                        fill: "white",
                                                        children: _jsx("use", {
                                                            xlinkHref: "#".concat(uniqueID, "PageNotFound-path-10")
                                                        })
                                                    }),
                                                    _jsx("g", {}),
                                                    _jsx("path", {
                                                        d: "M13.6235512,2.42658285 C19.9231618,2.42658285 19.9531444,7.34208235 20.3890244,9.8093881 C20.9425244,12.942484 19.9531444,17.8126597 18.280757,18.7978222 C17.3977171,19.3179994 16.9118202,19.5535269 15.7940873,20.0542587 C14.3099347,20.7191425 14.5520861,23.9966393 14.577308,25.6872184 L14.8962464,27.9417604 L6.1764924,27.9417604 L7.43901863,22.0611366 C7.74171903,20.4911031 8.70925167,16.8420265 8.10646888,16.197064 C6.32533795,14.2912985 5.48266595,13.0585883 5.48266595,10.8864002 C5.48266595,7.78898543 6.80095395,2.42658285 13.6235512,2.42658285 Z",
                                                        fill: "#DBB59D",
                                                        mask: "url(#".concat(uniqueID, "PageNotFound-mask-11)")
                                                    })
                                                ]
                                            }),
                                            _jsx("path", {
                                                d: "M9.02316578,0.0604800009 C12.2846857,0.0604800009 14.92867,2.6948842 14.92867,5.94458648 L14.9298894,5.9241211 C17.7910879,6.16566568 19.9103133,8.10584935 20.1938465,10.0239192 C20.1938465,11.4316077 18.3245872,12.7878381 17.1158403,13.3115038 C17.1158403,12.486453 15.9078144,11.2725688 14.8987532,12.1964496 C13.8210145,13.1832105 14.4564891,14.4029895 15.4082399,14.7436313 C12.4755391,16.1065576 13.443463,20.7661853 10.2158729,21.0836627 C6.98828273,21.4011401 5.84711902,18.4938791 5.35475338,15.7120452 C5.14519984,14.5280813 5.11402059,12.6402153 5.74877174,10.8413143 C4.16214111,9.78653829 3.1176616,7.98709606 3.1176616,5.94458648 C3.1176616,2.6948842 5.76164588,0.0604800009 9.02316578,0.0604800009 Z",
                                                fill: "#5B1E04"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            _jsxs("g", {
                                id: "PageNotFound-Rectangle-Copy-14-+-Rectangle-Copy-5-Mask",
                                transform: "translate(77.206155, 0.756000)",
                                children: [
                                    _jsx("mask", {
                                        id: "".concat(uniqueID, "PageNotFound-mask-14"),
                                        fill: "white",
                                        children: _jsx("use", {
                                            xlinkHref: "#".concat(uniqueID, "PageNotFound-path-13")
                                        })
                                    }),
                                    _jsx("use", {
                                        fill: "#ECECEC",
                                        fillOpacity: "0.7",
                                        xlinkHref: "#".concat(uniqueID, "PageNotFound-path-13")
                                    }),
                                    _jsxs("g", {
                                        filter: "url(#".concat(uniqueID, "PageNotFound-filter-16)"),
                                        mask: "url(#".concat(uniqueID, "PageNotFound-mask-14)"),
                                        strokeDasharray: "6.051600187683107",
                                        children: [
                                            _jsx("use", {
                                                fill: "black",
                                                filter: "url(#".concat(uniqueID, "PageNotFound-filter-17)"),
                                                fillOpacity: "1",
                                                xlinkHref: "#".concat(uniqueID, "PageNotFound-path-15")
                                            }),
                                            _jsx("use", {
                                                stroke: "url(#".concat(uniqueID, "PageNotFound-linearGradient-5)"),
                                                strokeWidth: "1.21032002",
                                                xlinkHref: "#".concat(uniqueID, "PageNotFound-path-15")
                                            })
                                        ]
                                    }),
                                    _jsxs("g", {
                                        filter: "url(#".concat(uniqueID, "PageNotFound-filter-19)"),
                                        mask: "url(#".concat(uniqueID, "PageNotFound-mask-14)"),
                                        children: [
                                            _jsx("use", {
                                                fill: "black",
                                                filter: "url(#".concat(uniqueID, "PageNotFound-filter-20)"),
                                                fillOpacity: "1",
                                                xlinkHref: "#".concat(uniqueID, "PageNotFound-path-18")
                                            }),
                                            _jsx("use", {
                                                fill: "url(#".concat(uniqueID, "PageNotFound-linearGradient-1)"),
                                                fillRule: "evenodd",
                                                xlinkHref: "#".concat(uniqueID, "PageNotFound-path-18")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            _jsxs("g", {
                                children: [
                                    _jsx("use", {
                                        fill: "black",
                                        filter: "url(#".concat(uniqueID, "PageNotFound-filter-24)"),
                                        fillOpacity: "1",
                                        xlinkHref: "#".concat(uniqueID, "PageNotFound-path-23")
                                    }),
                                    _jsx("use", {
                                        stroke: "url(#".concat(uniqueID, "PageNotFound-linearGradient-22)"),
                                        fill: "url(#".concat(uniqueID, "PageNotFound-linearGradient-21)"),
                                        strokeWidth: "1.51290002",
                                        fillRule: "evenodd",
                                        xlinkHref: "#".concat(uniqueID, "PageNotFound-path-23")
                                    })
                                ]
                            }),
                            _jsx("rect", {
                                id: "".concat(uniqueID, "PageNotFound-Rectangle-Copy-8"),
                                stroke: "url(#".concat(uniqueID, "PageNotFound-linearGradient-12)"),
                                x: "77.206155",
                                y: "0.756000012",
                                width: "75.6923089",
                                height: "142.128002",
                                rx: "4.73324424",
                                strokeWidth: "0.907740014"
                            })
                        ]
                    })
                })
            })
        ]
    }));
};
PageNotFound.defaultProps = {
    height: 400,
    width: 400
};
PageNotFound.isCarinaIllustration = true;
export default PageNotFound;
